<!--
 * @Author: vince
 * @Date: 2021-08-16 13:40:47
 * @LastEditors: vince 273187189@qq.com
 * @LastEditTime: 2023-03-12 09:01:59
 * @Description:
-->
<template>
  <div>
    <div class="state-bar pa-md mb-md">
      <el-row class="full-width">
        <el-col :span="4">
          <el-popconfirm title="确定放弃修改？" @confirm="$router.go(-1)">
            <el-button slot="reference">取消</el-button>
          </el-popconfirm>
        </el-col>
        <el-col :span="8" :offset="4">
          <div class="full-width" style="display: block">
            <el-steps :active="active" finish-status="success" align-center>
              <el-step>
                <template v-slot:title>
                  <el-button @click="active = 0" type="text"
                    >基本信息</el-button
                  >
                </template>
              </el-step>
              <el-step>
                <template v-slot:title>
                  <el-button @click="active = 1" type="text"
                    >学术文章</el-button
                  >
                </template>
              </el-step>
            </el-steps>
          </div>
        </el-col>
        <el-col :span="4" :offset="4" class="text-right">
          <el-button type="primary" icon="el-icon-upload2" @click="onPublish"
            >发布</el-button
          >
        </el-col>
      </el-row>
    </div>

    <div class="content-box pa-md bg-white">
      <el-tabs :value="currentTab" class="no-tab">
        <el-tab-pane name="0">
          <el-form
            :model="baseInfo"
            label-width="200px"
            ref="baseInfo"
            :rules="baseInfoRules"
          >
            <el-form-item label="学科" prop="disciplineTemp">
              <discipline v-model="baseInfo.disciplineTemp"></discipline>
            </el-form-item>
            <el-form-item label="年级" prop="gradeTemp">
              <grade-selector v-model="baseInfo.gradeTemp"></grade-selector>
            </el-form-item>
            <el-form-item label="作者" prop="otherAuthor">
              <author-selector v-model="baseInfo.otherAuthor"></author-selector>
            </el-form-item>
            <el-form-item class="text-center">
              <el-button type="primary" @click="onNextStep"
                >下一步 填写学术文章</el-button
              >
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane name="1">
          <!-- :rules="articleRules" -->
          <el-form :model="article" ref="article" :rules="articleRules">
            <el-form-item label="标题" prop="title">
              <el-input
                size="small"
                show-word-limit
                maxlength="20"
                class
                v-model="article.title"
                placeholder="请输入标题"
              ></el-input>
            </el-form-item>
            <el-form-item label="类型" prop="classify">
              <dic-selector
                dicType="academicEssay"
                v-model="article.classifyTemp"
                @change="
                  (v) => {
                    article.classify = v.dicCode
                  }
                "
              ></dic-selector>
            </el-form-item>
            <el-form-item label="级别" prop="scaleTemp">
              <dic-selector
                dicType="radiationlevel"
                v-model="article.scaleTemp"
              ></dic-selector>
            </el-form-item>
            <el-form-item label="发表" prop="isPublish">
              <el-radio-group v-model="article.isPublish">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <template v-if="article.isPublish == '1'">
              <el-form-item label="刊物名称" prop="periodicalName">
                <el-input
                  size="small"
                  show-word-limit
                  maxlength="20"
                  class
                  v-model="article.periodicalName"
                  placeholder="请输入刊物名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="发表时间" prop="publishDate">
                <el-date-picker
                  type="date"
                  placeholder="选择发表时间"
                  value-format="yyyy-MM-dd"
                  v-model="article.publishDate"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="是否独立完成" prop="isOnlyComplete">
                <el-radio-group v-model="article.isOnlyComplete">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                v-if="article.isOnlyComplete == 0"
                label="作者位次"
                prop="authorRank"
              >
                <el-select
                  placeholder="请选择作者位次"
                  v-model="article.authorRank"
                  size="small"
                >
                  <el-option
                    v-for="item in authorRankOptions"
                    :label="item.name"
                    :value="item.code"
                    :key="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </template>
            <el-form-item label="交流" prop="isExchange">
              <el-radio-group v-model="article.isExchange">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="获奖" prop="isAward">
              <el-radio-group v-model="article.isAward">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="外链" prop="link" placeholder="请输入外链地址">
              <el-input
                size="small"
                show-word-limit
                maxlength="100"
                v-model="article.link"
              ></el-input>
            </el-form-item>
            <el-form-item label="上传文件">
              <uploader
                multiple
                accept="*"
                listType="text"
                :maxSize="1 * 1024 * 1024 * 1024"
                :file-list.sync="article.articlesAttachDTOS"
              />
            </el-form-item>
            <el-form-item label="摘要">
              <div style="margin-left: 100px">
                <richTextEditor v-model="article.summary"></richTextEditor>
              </div>
            </el-form-item>
            <el-form-item class="text-center">
              <el-button type="primary" @click="onPreStep"
                >上一步 填写基本信息</el-button
              >
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import richTextEditor from '../../components/richTextEditor.vue'
import AuthorSelector from '../../components/school/authorSelector.vue'
import dicSelector from '../../components/school/dicSelector.vue'
import Discipline from '../../components/school/disciplineSelector.vue'
import GradeSelector from '../../components/school/gradeSelector.vue'
import uploader from '../../components/school/uploader.vue'
import { postData, postJson } from '../../http/fetch'
export default {
  name: 'academicEssayAdd',
  components: {
    Discipline,
    dicSelector,
    GradeSelector,
    AuthorSelector,
    uploader,
    richTextEditor
  },
  props: {
    id: {
      type: Number | String
    }
  },
  data() {
    var validatorLink = (rule, value, callback) => {
      if (
        (this.article.link.length > 0 && this.isURL(this.article.link)) ||
        this.article.link.length == 0
      ) {
        callback()
      } else {
        return callback(new Error('请输入正确的外链'))
      }
    }
    return {
      loading: false,
      active: 0,
      fileList: [],
      authorRankOptions: [],
      baseInfo: {
        infoCode: '',
        disciplineTemp: null,
        disciplineCode: '',
        disciplineName: '',
        grade: null,
        gradeName: null,
        gradeTemp: null,
        otherAuthor: []
      },
      article: {
        title: '',
        classify: '',
        classifyTemp: {},
        isPublish: '0',
        isExchange: '0',
        isOnlyComplete: 0,
        isAward: '0',
        link: '',
        articlesAttachDTOS: [],
        summary: '',
        scaleTemp: null,
        scale: null,
        periodicalName: '',
        publishDate: '',
        authorRank: ''
      },
      baseInfoRules: {
        disciplineTemp: {
          required: true,
          message: '请选择学科',
          trigger: 'change'
        },
        // gradeTemp: {
        //   required: true,
        //   message: "请选择年级",
        //   trigger: "change",
        // },
        otherAuthor: {
          required: true,
          message: '请选择作者',
          trigger: 'change'
        }
      },
      articleRules: {
        title: { required: true, message: '请输入标题', trigger: 'blur' },
        periodicalName: {
          required: true,
          message: '请输入刊物名称',
          trigger: 'blur'
        },
        publishDate: {
          required: true,
          message: '请选择发表时间',
          trigger: 'blur'
        },
        classify: { required: true, message: '请选择类型', trigger: 'blur' },
        isOnlyComplete: {
          required: true,
          message: '请选择是否独立完成',
          trigger: 'change'
        },
        authorRank: {
          required: true,
          message: '请选择作者位次',
          trigger: 'change'
        },
        link: {
          validator: validatorLink,
          required: false,
          trigger: 'change'
        }
        // scaleTemp: { required: true, message: "请选择级别", trigger: "change" },
      }
    }
  },
  computed: {
    currentTab() {
      return `${this.active}`
    },
    ...mapState(['userInfo']),
    ...mapGetters(['operatorId', 'schoolCode'])
  },
  mounted() {
    this.getAuthorRankList()
    if (this.id) {
      this.getData()
    } else {
      this.baseInfo.otherAuthor = [
        {
          schoolCode: this.schoolCode,
          userId: this.operatorId,
          userName: this.userInfo.userName
        }
      ]
    }
  },
  methods: {
    getAuthorRankList() {
      postData('/teacherArticles/getAuthorRankList').then((res) => {
        this.authorRankOptions = res
      })
    },
    isURL(strUrl) {
      var regular =
        /^\b(((https?|ftp):\/\/)?[-a-z0-9]+(\.[-a-z0-9]+)*\.(?:com|edu|gov|int|mil|net|org|biz|info|name|museum|asia|coop|aero|[a-z][a-z]|((25[0-5])|(2[0-4]\d)|(1\d\d)|([1-9]\d)|\d))\b(\/[-a-z0-9_:\@&?=+,.!\/~%\$]*)?)$/i
      if (regular.test(strUrl)) {
        return true
      } else {
        return false
      }
    },
    onPreStep() {
      this.active = 0
    },
    onNextStep() {
      this.active = 1
    },
    resetForm() {
      this.$refs.baseInfo.resetFields()
      this.$refs.article.resetFields()
    },
    getData() {
      this.loading = true
      postData('/teacherArticles/getTeacherArticles', {
        id: this.id,
        operatorId: this.operatorId
      })
        .then((res) => {
          this.baseInfo.id = res.id
          this.baseInfo.infoCode = res.infoCode
          this.baseInfo.disciplineTemp = {
            disciplineCode: res.disciplineCode,
            disciplineName: res.disciplineName
          }
          this.baseInfo.disciplineCode = res.disciplineCode
          this.baseInfo.disciplineName = res.disciplineName

          this.baseInfo.gradeTemp = {
            grade: res.grade,
            gradeName: res.gradeName
          }
          this.baseInfo.grade = res.grade
          this.baseInfo.gradeName = res.gradeName

          this.article.link = res.link
          this.article.title = res.title
          this.article.periodicalName = res.periodicalName
          this.article.publishDate = res.publishDate
          this.article.classify = res.classify
          this.article.classifyTemp = {
            dicCode: res.classify
          }

          this.article.summary = res.summary
          this.article.scale = res.scale
          this.article.scaleTemp = {
            dicCode: res.scale
          }
          this.article.isAward = res.isAward
          this.article.isExchange = res.isExchange
          this.article.isOnlyComplete = res.isOnlyComplete
          this.article.authorRank = res.authorRank
          this.article.isPublish = res.isPublish
          if (res.articlesAttachDTOS.length) {
            this.article.articlesAttachDTOS = res.articlesAttachDTOS.map(
              (m) => {
                m.name = m.attachUrl
                m.status = 'success'
                return m
              }
            )
          }

          let otherAuthor = JSON.parse(res.otherAuthor)
          this.baseInfo.otherAuthor = otherAuthor.map((m) => {
            if (m.schoolCode) {
              return m
            } else {
              return m.userId
            }
          })
        })
        .catch((e) => {
          console.error(e)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async onPublish() {
      await this.$refs.baseInfo.validate((valid) => {
        if (valid) {
          return true
        } else {
          this.active = 0
          return false
        }
      })
      await this.$refs.article.validate((vld) => {
        if (vld) {
          postJson('/teacherArticles/saveOrUpdateTeacherArticles', {
            classify: this.article.classifyTemp.dicCode,
            articlesAttachDTOS: this.article.articlesAttachDTOS.length
              ? this.article.articlesAttachDTOS.map((m) => {
                  return {
                    attachSize: m.attachSize,
                    attachType: m.attachType,
                    attachUrl: m.attachUrl,
                    attachName: m.attachName
                  }
                })
              : [],
            disciplineCode: this.baseInfo.disciplineTemp.disciplineCode,
            disciplineName: this.baseInfo.disciplineTemp.disciplineName,
            grade: this.baseInfo.gradeTemp
              ? this.baseInfo.gradeTemp.grade
              : null,
            gradeName: this.baseInfo.gradeTemp
              ? this.baseInfo.gradeTemp.gradeName
              : null,
            id: this.id ? this.id : null,
            infoCode: this.baseInfo.infoCode ? this.baseInfo.infoCode : null,
            isOnline: 1,
            link: this.article.link,
            operatorId: this.operatorId,
            otherAuthor: this.baseInfo.otherAuthor.length
              ? JSON.stringify(
                  this.baseInfo.otherAuthor.map((m) => {
                    if (typeof m == 'string') {
                      return {
                        userId: m,
                        schoolCode: null,
                        userName: m
                      }
                    } else {
                      return {
                        userId: m.userId,
                        schoolCode: m.schoolCode,
                        userName: m.userName
                      }
                    }
                  })
                )
              : '',
            schoolCode: this.schoolCode,
            title: this.article.title,
            periodicalName: this.article.periodicalName,
            publishDate: this.article.publishDate,
            schoolCode: this.schoolCode,
            isAward: this.article.isAward,
            isPublish: this.article.isPublish,
            isExchange: this.article.isExchange,
            isOnlyComplete: this.article.isOnlyComplete,
            authorRank: this.article.authorRank,
            summary: this.article.summary,
            scale: this.article.scaleTemp.dicCode
          })
            .then((res) => {
              this.$message.success('发布成功！')
              this.$router.push({ name: 'academicEssay' })
            })
            .catch((e) => {
              //this.$message.error("发布失败！");
            })
        } else {
          this.active = 1
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.uploader {
  display: inline-block;
}
</style>
